import { render, staticRenderFns } from "./officialMessage.vue?vue&type=template&id=7f712d39&scoped=true&"
import script from "./officialMessage.vue?vue&type=script&lang=js&"
export * from "./officialMessage.vue?vue&type=script&lang=js&"
import style0 from "./officialMessage.vue?vue&type=style&index=0&id=7f712d39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f712d39",
  null
  
)

export default component.exports